import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetDriverById } from "./deliveryZoneExisting.request";
import {
  DeliveryZoneExistingRequestParams,
  DeliveryZoneExistingResponse
} from "./deliveryZoneExisting.types";

const useDeliveryZoneExisting = (
  params: DeliveryZoneExistingRequestParams,
  options?: QueryOptions<
    DeliveryZoneExistingResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["admin", "delivery", "zones", params],
    queryFn: async () => {
      return await requestGetDriverById(params);
    },
    enabled: !!params.city && !!params.country && !!params.neighborhood,
    cacheTime: 0,
    ...options
  });

  return { isZoneExisting: !!data?.exists, ...rest };
};

export default useDeliveryZoneExisting;
